(function () {
  'use strict';

  function initProduktseiteFarbfinder(root) {
    if (!root || root.dataset.pfInit) return;
    root.dataset.pfInit = '1';

    var dataEl = root.querySelector('[data-pf-colors]');
    var colors = [];
    try { colors = JSON.parse(dataEl.textContent); } catch (e) { colors = []; }

    var bundleEl = root.querySelector('[data-pf-bundles]');
    var bundles = [];
    try { bundles = JSON.parse(bundleEl.textContent); } catch (e) { bundles = []; }
    bundles.sort(function (a, b) { return a.qty - b.qty; });

    var colorPosition = parseInt(root.getAttribute('data-pf-color-position'), 10);
    if (isNaN(colorPosition)) colorPosition = -1;
    var optionNoun = root.getAttribute('data-pf-option-noun') || 'Optionen';

    var moneyFmt = root.getAttribute('data-pf-money-format') || '{{amount}} €';
    // Tausender mit Punkt wie Shopifys money-Filter (amount_with_comma_separator),
    // damit 1.234,50 € aus dem Skript genauso aussieht wie aus dem Liquid.
    function money(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+,)/g, '.');
      return moneyFmt.replace(/\{\{\s*[\w_]+\s*\}\}/, amount);
    }

    // RAL-Classic-Tabelle (Näherungswerte) als Rückfall für Farben ohne hinterlegten Hex-Wert
    var RAL_HEX = {1000:'#CDBA88',1001:'#D0B084',1002:'#D2AA6D',1003:'#F9A800',1004:'#E49E00',1005:'#CB8E00',1006:'#E29000',1007:'#E88C00',1011:'#AF804F',1012:'#DDAF27',1013:'#E3D9C6',1014:'#DDC49A',1015:'#E6D2B5',1016:'#F1DD38',1017:'#F6A950',1018:'#FACA30',1019:'#A48F7A',1020:'#A08F65',1021:'#F6B600',1023:'#F7B500',1024:'#BA8F4C',1026:'#FFFF00',1027:'#A77F0E',1028:'#FF9B00',1032:'#E2A300',1033:'#F99A1C',1034:'#EB9C52',1035:'#908370',1036:'#80643F',1037:'#F09200',2000:'#DA6E00',2001:'#BA481B',2002:'#BF3922',2003:'#F67828',2004:'#E25303',2005:'#FF4D06',2007:'#FFB200',2008:'#ED6B21',2009:'#DE5307',2010:'#D05D28',2011:'#E26E0E',2012:'#D5654E',2013:'#923E25',3000:'#A72920',3001:'#9B2423',3002:'#9B2321',3003:'#8A1C29',3004:'#6B1C23',3005:'#59191F',3007:'#3E2022',3009:'#6D342D',3011:'#792423',3012:'#C6846D',3013:'#972E25',3014:'#CB7375',3015:'#D8A0A6',3016:'#A63D2F',3017:'#CB555D',3018:'#C73F4A',3020:'#BB1E10',3022:'#CF6955',3024:'#FF2D21',3026:'#FF2A1B',3027:'#B42041',3028:'#E73E29',3031:'#AC323B',3032:'#711521',3033:'#B24C43',4001:'#8A5A83',4002:'#933D50',4003:'#D15B8F',4004:'#691639',4005:'#83639D',4006:'#992572',4007:'#4A192C',4008:'#924E7D',4009:'#A18594',4010:'#CF3476',4011:'#8673A1',4012:'#6C6874',5000:'#354D73',5001:'#1F3438',5002:'#20214F',5003:'#1D1E33',5004:'#18171C',5005:'#1E2460',5007:'#3E5F8A',5008:'#26252D',5009:'#025669',5010:'#0E294B',5011:'#231A24',5012:'#3B83BD',5013:'#1E213D',5014:'#606E8C',5015:'#2271B3',5017:'#063971',5018:'#3F888F',5019:'#1B5583',5020:'#1D334A',5021:'#256D7B',5022:'#252850',5023:'#49678D',5024:'#5D9B9B',5025:'#2A6478',5026:'#102C54',6000:'#316650',6001:'#287233',6002:'#2D572C',6003:'#424632',6004:'#1F3A3D',6005:'#2F4538',6006:'#3E3B32',6007:'#343B29',6008:'#39352A',6009:'#31372B',6010:'#35682D',6011:'#587246',6012:'#343E40',6013:'#6C7156',6014:'#47402E',6015:'#3B3C36',6016:'#1E5945',6017:'#4C9141',6018:'#57A639',6019:'#BDECB6',6020:'#2E3A23',6021:'#89AC76',6022:'#25221B',6024:'#308446',6025:'#3D642D',6026:'#015D52',6027:'#84C3BE',6028:'#2C5545',6029:'#20603D',6032:'#317F43',6033:'#497E76',6034:'#7FB5B5',6035:'#1C542D',6036:'#193737',6037:'#008F39',6038:'#00BB2D',7000:'#78858B',7001:'#8A9597',7002:'#7E7B52',7003:'#6C7059',7004:'#969992',7005:'#646B63',7006:'#6D6552',7008:'#6A5F31',7009:'#4D5645',7010:'#4C514A',7011:'#434B4D',7012:'#4E5754',7013:'#464531',7015:'#434750',7016:'#293133',7021:'#23282B',7022:'#332F2C',7023:'#686C5E',7024:'#474A51',7026:'#2F353B',7030:'#8B8C7A',7031:'#474B4E',7032:'#B8B799',7033:'#7D8471',7034:'#8F8B66',7035:'#D7D7D7',7036:'#7F7679',7037:'#7D7F7D',7038:'#B5B8B1',7039:'#6C6960',7040:'#9DA1AA',7042:'#8D948D',7043:'#4E5452',7044:'#CAC4B0',7045:'#909090',7046:'#82898F',7047:'#D0D0D0',7048:'#898176',8000:'#826C34',8001:'#955F20',8002:'#6C3B2A',8003:'#734222',8004:'#8E402A',8007:'#59351F',8008:'#6F4F28',8011:'#5B3A29',8012:'#592321',8014:'#382C1E',8015:'#633A34',8016:'#4C2F27',8017:'#45322E',8019:'#403A3A',8022:'#212121',8023:'#A65E2E',8024:'#79553D',8025:'#755C48',8028:'#4E3B31',8029:'#763C28',9001:'#FDF4E3',9002:'#E7EBDA',9003:'#F4F4F4',9004:'#282828',9005:'#0A0A0A',9006:'#A5A5A5',9007:'#8F8F8F',9010:'#FFFFFF',9011:'#1C1C1C',9016:'#F6F6F6',9017:'#1E1E1E',9018:'#D7D7D7',9022:'#9C9C9C',9023:'#828282'};

    // Farbnamen ohne RAL-Nummer (Klarlack, Grundierungen, Effektlacke).
    // Wird nur benutzt, wenn das Liquid keinen echten Farbwert liefert.
    var NAME_HEX = {
      schwarz: '#0A0A0A', tiefschwarz: '#0A0A0A', anthrazit: '#383E42',
      weiss: '#FFFFFF', 'weiß': '#FFFFFF', reinweiss: '#FFFFFF', verkehrsweiss: '#F6F6F6', cremeweiss: '#FDF4E3',
      grau: '#9C9C9C', hellgrau: '#D7D7D7', dunkelgrau: '#4E5452', lichtgrau: '#D7D7D7', silbergrau: '#B5B8B1',
      beige: '#CDBA88', elfenbein: '#E6D2B5', creme: '#E3D9C6', natur: '#DDC49A', sand: '#D2AA6D',
      rotbraun: '#8E402A', braun: '#734222', kupfer: '#B4653A', bronze: '#8C7853', rost: '#A65E2E',
      rot: '#A72920', feuerrot: '#A72920', weinrot: '#711521',
      blau: '#0E294B', hellblau: '#3B83BD', dunkelblau: '#102C54',
      'grün': '#287233', gruen: '#287233', 'hellgrün': '#57A639', 'dunkelgrün': '#2D572C',
      gelb: '#F9A800', orange: '#F67828', violett: '#8A5A83', rosa: '#D8A0A6',
      silber: '#A5A5A5', alu: '#A5A5A5', aluminium: '#A5A5A5', chrom: '#C0C4C7',
      gold: '#C9A227', messing: '#B5A642', zink: '#8F8F8F'
    };
    // Farblos: kein Farbwert, sondern als Glas-Verlauf dargestellt.
    var CLEAR_WORDS = ['klarlack', 'klar', 'farblos', 'transparent', 'blank'];
    var CLEAR_GRAD = 'linear-gradient(135deg,#ffffff 0 42%,#dcdcdc 42% 58%,#ffffff 58%)';

    if (colorPosition > -1) {
      colors.forEach(function (c) {
        if (c.code || c.grad) return;
        var raw = (c.options && c.options[colorPosition]) || '';

        // 1) RAL-Nummer im Optionsnamen
        var m = /RAL\s*(\d{4})\s*[-–:]?\s*(.*)$/i.exec(raw);
        if (m && RAL_HEX[m[1]]) {
          c.code = 'RAL ' + m[1];
          c.name = m[2] || c.name;
          c.hex = RAL_HEX[m[1]];
          c.label = (c.code + ' ' + c.name).trim();
          return;
        }

        // 2) Farbname im Optionsnamen — nur wenn das Liquid keinen echten Wert
        //    hinterlegt hat (#cccccc ist dessen Platzhalter).
        var placeholder = !c.hex || String(c.hex).toLowerCase() === '#cccccc';
        if (!placeholder) return;

        // Wortweise vergleichen, damit "Grundierung" nicht versehentlich als
        // Farbe durchgeht. Der LETZTE Treffer gewinnt: im Deutschen steht das
        // bestimmende Farbwort hinten ("Bronze Gold" ist gold, nicht bronze).
        var tokens = raw.toLowerCase().split(/[^a-zäöüß]+/).filter(Boolean);
        var best = '';
        tokens.forEach(function (t) {
          if (CLEAR_WORDS.indexOf(t) > -1) { c.grad = CLEAR_GRAD; best = ''; return; }
          if (NAME_HEX[t]) { best = t; c.grad = ''; }
        });
        if (!c.grad && best) c.hex = NAME_HEX[best];
      });
    }

    // extracts the leading RAL number from a color code, e.g. "RAL1015" -> 1015
    function ralNum(c) {
      var m = /(\d+)/.exec(c.code || '');
      return m ? parseInt(m[1], 10) : Infinity;
    }

    function byVariantId(id) {
      for (var i = 0; i < colors.length; i++) if (String(colors[i].variantId) === String(id)) return colors[i];
      return colors[0];
    }

    // ---------- Optionspositionen ----------
    // allPositions = alle Optionen des Produkts, otherPositions = alles außer der Farbe
    // (z. B. Größe). Bewusst generisch: funktioniert mit einer wie mit mehreren
    // Zusatzoptionen, egal in welcher Reihenfolge sie im Produkt stehen.
    var allPositions = (function () {
      var n = 0;
      colors.forEach(function (c) { n = Math.max(n, (c.options || []).length); });
      var out = [];
      for (var i = 0; i < n; i++) out.push(i);
      return out;
    })();
    var otherPositions = allPositions.filter(function (i) { return i !== colorPosition; });

    // Stimmt die Variante an den genannten Positionen mit der aktuellen Auswahl überein?
    function matchesAt(c, positions) {
      for (var k = 0; k < positions.length; k++) {
        var j = positions[k];
        var want = state.optionValues[j];
        if (want != null && (c.options || [])[j] !== want) return false;
      }
      return true;
    }

    // Welche Werte einer Option gibt es für diese Farbe überhaupt?
    function valuesForColorAt(colorKey, position) {
      var out = [];
      colors.forEach(function (c) {
        if ((c.options || [])[colorPosition] !== colorKey) return;
        var v = c.options[position];
        if (v && out.indexOf(v) === -1) out.push(v);
      });
      return out;
    }

    // Warum ist diese Farbe gerade nicht wählbar? Liefert die Werte, in denen es sie gibt.
    function blockedValues(colorKey) {
      for (var k = 0; k < otherPositions.length; k++) {
        var j = otherPositions[k];
        var want = state.optionValues[j];
        if (want == null) continue;
        var vals = valuesForColorAt(colorKey, j);
        if (vals.length && vals.indexOf(want) === -1) return vals;
      }
      return null;
    }

    var initialEntry = byVariantId(root.getAttribute('data-pf-initial-variant'));

    var state = {
      variantId: initialEntry ? initialEntry.variantId : root.getAttribute('data-pf-initial-variant'),
      optionValues: (initialEntry && initialEntry.options) ? initialEntry.options.slice() : [],
      gloss: 'Alle',
      search: '',
      qty: bundles.length ? bundles[0].qty : 1
    };

    // findet die Variante, deren Optionen an jeder bekannten Position mit state.optionValues übereinstimmen
    function resolveVariant() {
      for (var i = 0; i < colors.length; i++) {
        var opts = colors[i].options || [];
        var ok = true;
        for (var j = 0; j < state.optionValues.length; j++) {
          var want = state.optionValues[j];
          if (want != null && opts[j] !== want) { ok = false; break; }
        }
        if (ok) return colors[i];
      }
      return byVariantId(state.variantId) || colors[0];
    }

    // ---------- media: zwei fest sichtbare Reihen (Bilder / Videos) ----------
    var heroImg = root.querySelector('[data-pf-hero-img]');
    var heroVideoWrap = root.querySelector('[data-pf-hero-video-wrap]');
    var heroPlay = root.querySelector('[data-pf-hero-play]');
    var mediaRowsWrap = root.querySelector('[data-pf-media-rows]');

    function setHero(src, isVideo) {
      if (isVideo) {
        if (heroImg) heroImg.style.display = 'none';
        if (heroVideoWrap) heroVideoWrap.style.display = '';
        if (heroPlay) heroPlay.style.display = '';
        var video = heroVideoWrap ? heroVideoWrap.querySelector('video') : null;
        if (video) { try { video.pause(); video.currentTime = 0; } catch (e3) {} }
      } else {
        if (heroImg) { heroImg.src = src; heroImg.style.display = ''; }
        if (heroVideoWrap) heroVideoWrap.style.display = 'none';
      }
    }

    if (mediaRowsWrap) {
      mediaRowsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-pf-thumb]');
        if (!btn) return;
        mediaRowsWrap.querySelectorAll('[data-pf-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        setHero(btn.getAttribute('data-src'), btn.getAttribute('data-video') === '1');
      });
    }

    if (heroPlay) {
      heroPlay.addEventListener('click', function () {
        var video = heroVideoWrap ? heroVideoWrap.querySelector('video') : null;
        if (video) { video.play(); heroPlay.style.display = 'none'; }
      });
    }

    // ---------- selection summary (trigger button, sticky bar, hero overlay) ----------
    var selChipEls = root.querySelectorAll('[data-pf-sel-chip]');
    var selLabelEls = root.querySelectorAll('[data-pf-sel-label]');
    var selGlossEls = root.querySelectorAll('[data-pf-sel-gloss]');
    var stockEls = root.querySelectorAll('[data-pf-sel-stock]');
    var variantInput = root.querySelector('[data-pf-variant-input]');

    function paintChip(el, color) {
      if (color.grad) { el.style.background = color.grad; }
      else { el.style.background = color.hex; }
    }

    function renderSelection() {
      var c = byVariantId(state.variantId);
      if (!c) return;
      selChipEls.forEach(function (el) { paintChip(el, c); });
      selLabelEls.forEach(function (el) { el.textContent = c.label; });
      selGlossEls.forEach(function (el) { el.textContent = [c.gloss, 'Art.-Nr. ' + c.sku].filter(Boolean).join(' · '); });
      stockEls.forEach(function (el) {
        el.textContent = c.available ? 'Auf Lager · heute versandfertig' : 'Ausverkauft · benachrichtigen lassen';
        el.style.color = c.available ? 'var(--pf-accent-700)' : 'var(--pf-neutral-600)';
      });
      if (variantInput) variantInput.value = c.variantId;
      applyVariantPrice(c);
      setHero(c.img, false);
      renderOptionSegs();
      updateAddToCartState();
    }

    function updateAddToCartState() {
      var c = byVariantId(state.variantId);
      var disabled = !c || !c.available;
      root.querySelectorAll('[data-pf-add-to-cart]').forEach(function (btn) { btn.disabled = disabled; });
    }

    // ---------- swatch picking (Farbfinder: Drawer) ----------
    root.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-pf-pick]');
      if (!pick) return;
      var picked = byVariantId(pick.getAttribute('data-pf-pick'));
      if (picked && picked.options) {
        if (colorPosition > -1) state.optionValues[colorPosition] = picked.options[colorPosition];
        else state.optionValues = picked.options.slice();
      }
      state.variantId = resolveVariant().variantId;
      renderSelection();
      renderDrawerList();
      closeDrawer();
    });

    // ---------- generische Auswahl für weitere Optionen (z. B. Größe) ----------
    root.querySelectorAll('[data-pf-opt-seg]').forEach(function (seg) {
      var position = parseInt(seg.getAttribute('data-pf-opt-position'), 10);
      seg.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-pf-opt-value]');
        if (!opt) return;
        var val = opt.getAttribute('data-pf-opt-value');
        state.optionValues[position] = val;

        // Gibt es die aktuelle Farbe in diesem Wert nicht, wird auf die erste
        // lieferbare Farbe dieses Werts gewechselt. Sonst bliebe eine Auswahl
        // stehen, zu der es überhaupt keine Variante gibt.
        var exists = colors.some(function (c) { return matchesAt(c, allPositions); });
        if (!exists) {
          var alt = colors.filter(function (c) { return (c.options || [])[position] === val; });
          var fallback = alt.filter(function (c) { return c.available; })[0] || alt[0];
          if (fallback) state.optionValues = fallback.options.slice();
        }

        state.variantId = resolveVariant().variantId;
        renderSelection();
        renderDrawerList();
      });
    });

    // Markiert je Option, welche Werte es zur aktuell gewählten Farbe gibt.
    function renderOptionSegs() {
      root.querySelectorAll('[data-pf-opt-seg]').forEach(function (seg) {
        var position = parseInt(seg.getAttribute('data-pf-opt-position'), 10);
        if (isNaN(position)) return;
        seg.querySelectorAll('[data-pf-opt-value]').forEach(function (o) {
          var val = o.getAttribute('data-pf-opt-value');
          o.classList.toggle('is-active', state.optionValues[position] === val);
          var possible = colors.some(function (c) {
            if ((c.options || [])[position] !== val) return false;
            if (colorPosition > -1 && state.optionValues[colorPosition] != null &&
                c.options[colorPosition] !== state.optionValues[colorPosition]) return false;
            return true;
          });
          o.classList.toggle('is-oos', !possible);
          if (possible) o.removeAttribute('title');
          else o.setAttribute('title', 'In der gewählten Farbe nicht erhältlich');
        });
      });
    }

    // ---------- drawer / dialog open/close ----------
    var drawer = root.querySelector('[data-pf-drawer]');
    var backdrop = root.querySelector('[data-pf-drawer-backdrop]');

    function openDrawer() {
      if (drawer) drawer.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (drawer) drawer.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    root.querySelectorAll('[data-pf-open-drawer]').forEach(function (b) { b.addEventListener('click', openDrawer); });
    root.querySelectorAll('[data-pf-close-drawer]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // ---------- drawer: gloss segmented control ----------
    root.querySelectorAll('[data-pf-gloss-seg]').forEach(function (seg) {
      seg.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-pf-gloss]');
        if (!opt) return;
        state.gloss = opt.getAttribute('data-pf-gloss');
        root.querySelectorAll('[data-pf-gloss]').forEach(function (o) {
          o.classList.toggle('is-active', o.getAttribute('data-pf-gloss') === state.gloss);
        });
        renderDrawerList();
      });
    });

    // ---------- drawer: search ----------
    root.querySelectorAll('[data-pf-search]').forEach(function (input) {
      input.addEventListener('input', function () {
        state.search = input.value.trim().toLowerCase();
        renderDrawerList();
      });
    });

    var drawerListEl = root.querySelector('[data-pf-drawer-list]');
    var drawerCountEls = root.querySelectorAll('[data-pf-drawer-count]');

    // Jede Farbe genau einmal. fits = es gibt sie in der aktuell gewählten Größe;
    // passende Variante wird bevorzugt, sonst dient eine andere als Platzhalter
    // für die Zeile "nur in ... erhältlich".
    function colorEntries() {
      if (colorPosition < 0) {
        return colors.map(function (c) { return { c: c, fits: true, key: '' }; });
      }
      var seen = {}, out = [];
      colors.forEach(function (c) {
        var key = c.options[colorPosition];
        var fits = matchesAt(c, otherPositions);
        if (seen[key] === undefined) {
          seen[key] = out.length;
          out.push({ c: c, fits: fits, key: key });
        } else if (!out[seen[key]].fits && fits) {
          out[seen[key]] = { c: c, fits: true, key: key };
        }
      });
      return out;
    }

    function renderDrawerList() {
      if (!drawerListEl) return;
      var entries = colorEntries();
      var filtered = entries.filter(function (e) {
        var c = e.c;
        if (state.gloss !== 'Alle' && c.gloss !== state.gloss) return false;
        if (state.search) {
          var hay = (c.code + ' ' + c.name).toLowerCase();
          if (hay.indexOf(state.search) === -1) return false;
        }
        return true;
      });

      // nach RAL-Nummer aufsteigend; ohne RAL-Nummern alphabetisch nach Name
      var sorted = filtered.slice().sort(function (a, b) {
        var na = ralNum(a.c), nb = ralNum(b.c);
        if (na !== nb) return na - nb;
        if (a.c.name !== b.c.name) return a.c.name < b.c.name ? -1 : 1;
        return (a.c.gloss || '').localeCompare(b.c.gloss || '');
      });

      var hasRal = entries.some(function (e) { return ralNum(e.c) !== Infinity; });
      var noun = hasRal ? 'Farbtöne' : (/^farbe$/i.test(optionNoun) ? 'Farben' : optionNoun);
      var pickable = sorted.filter(function (e) { return e.fits; }).length;

      drawerCountEls.forEach(function (el) {
        var txt = sorted.length + ' ' + noun;
        if (pickable !== sorted.length) txt += ' · ' + pickable + ' in dieser Auswahl';
        else if (hasRal) txt += ' · RAL aufsteigend';
        el.textContent = txt;
      });

      var html = '<div class="pf-drawer-flat-grid">';
      sorted.forEach(function (e) {
        var c = e.c;
        var blocked = !e.fits;
        var oos = e.fits && !c.available;
        var dim = blocked || oos;
        var active = String(c.variantId) === String(state.variantId);
        var bg = c.grad ? c.grad : c.hex;
        var vals = blocked ? blockedValues(e.key) : null;
        var note = blocked
          ? (vals && vals.length ? ' · nur in ' + vals.join(' / ') + ' erhältlich' : ' · nicht verfügbar')
          : (oos ? ' · ausverkauft' : '');
        html += '<button type="button" class="pf-drawer-color-row' + (active ? ' is-active' : '') + (dim ? ' is-oos' : '') + '"' + (blocked ? ' disabled aria-disabled="true"' : '') + ' data-pf-pick="' + c.variantId + '">';
        html += '<span class="pf-drawer-color-chip' + (dim ? ' is-oos' : '') + '" style="background:' + bg + '"></span>';
        html += '<span class="pf-drawer-color-text"><span class="pf-drawer-color-line1">' + (c.code || c.name) + '</span><span class="pf-drawer-color-line2">' + (c.code ? [c.name, c.gloss].filter(Boolean).join(' · ') : c.gloss) + note + '</span></span>';
        html += '</button>';
      });
      html += '</div>';
      drawerListEl.innerHTML = sorted.length ? html : '<p style="font-size:13px;color:var(--pf-neutral-600)">Nichts gefunden.</p>';
    }

    // ---------- bundle tiles + Mengen-Stepper ----------
    var bundleWraps = root.querySelectorAll('[data-pf-bundles-wrap]');
    var qtyInputs = root.querySelectorAll('[data-pf-qty-input]');
    var qtyValEls = root.querySelectorAll('[data-pf-qty-val]');
    var ctaTotalEls = root.querySelectorAll('[data-pf-cta-total]');
    var perUnitEls = root.querySelectorAll('[data-pf-per-unit]');
    var shipHintEls = root.querySelectorAll('[data-pf-ship-hint]');

    // größter Mengenrabatt-Tarif, der auf `qty` anwendbar ist -> Einzelpreis daraus ableiten
    function unitPriceFor(qty) {
      var applicable = bundles.length ? bundles[0] : { qty: 1, total: 0 };
      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].qty <= qty) applicable = bundles[i];
      }
      return Math.round(applicable.total / applicable.qty);
    }

    function shipLabel(totalCents) {
      var total = totalCents / 100;
      if (total >= 85) return 'Versand gratis';
      if (total > 35) return 'Versand 2,90 € · gratis ab 85 €';
      return 'Versand 4,90 € · gratis ab 85 €';
    }

    function renderPurchase() {
      if (state.qty < 1) state.qty = 1;
      var unit = unitPriceFor(state.qty);
      var total = unit * state.qty;

      bundleWraps.forEach(function (wrap) {
        wrap.querySelectorAll('[data-pf-bundle-tile]').forEach(function (tile) {
          var qty = parseInt(tile.getAttribute('data-pf-bundle-tile'), 10);
          tile.classList.toggle('is-active', qty === state.qty);
        });
      });
      qtyInputs.forEach(function (el) { el.value = state.qty; });
      qtyValEls.forEach(function (el) { el.textContent = state.qty; });
      ctaTotalEls.forEach(function (el) { el.textContent = money(total); });
      perUnitEls.forEach(function (el) { el.textContent = money(unit); });
      shipHintEls.forEach(function (el) { el.textContent = shipLabel(total); });
    }

    // ---------- Preise der gewählten Variante ----------
    // Hauptpreis, Kacheln und „ab … im 6er-Set“ rendert das Liquid für die
    // Variante, mit der die Seite geladen wurde. Wechselt man auf eine Variante
    // mit anderem Preis (z. B. 750 ml → 5 l), blieben sonst überall die alten
    // Beträge stehen. Gerechnet wie in pf-buybox.liquid und im Warenkorb: der
    // Rabatt (off, in Prozent) je Stück, auf den Cent abgerundet.
    var priceMainEls = root.querySelectorAll('.pf-price-main');
    var priceBestEls = root.querySelectorAll('.pf-price-best-val');
    bundles.forEach(function (b) {
      if (typeof b.off !== 'number') b.off = b.list ? Math.round(100 - b.total * 100 / b.list) : 0;
    });

    function setTileText(tile, selector, text) {
      var el = tile.querySelector(selector);
      if (el) el.textContent = text;
    }

    function applyVariantPrice(c) {
      var base = c ? parseInt(c.price, 10) : NaN;
      if (isNaN(base) || !bundles.length || bundles[0].total === base) return;
      bundles.forEach(function (b) {
        b.total = (base - Math.floor(base * b.off / 100)) * b.qty;
        if (b.list) b.list = base * b.qty;
      });
      bundleWraps.forEach(function (wrap) {
        wrap.querySelectorAll('[data-pf-bundle-tile]').forEach(function (tile) {
          var qty = parseInt(tile.getAttribute('data-pf-bundle-tile'), 10);
          var b = bundles.filter(function (x) { return x.qty === qty; })[0];
          if (!b) return;
          setTileText(tile, '.pf-bundle-each', money(Math.round(b.total / b.qty)));
          setTileText(tile, '.pf-bundle-sum', 'Gesamt ' + money(b.total));
          setTileText(tile, '.pf-bundle-list', b.list ? money(b.list) : '');
        });
      });
      priceMainEls.forEach(function (el) { el.textContent = money(base); });
      var best = bundles[bundles.length - 1];
      if (best.qty > 1) {
        priceBestEls.forEach(function (el) { el.textContent = 'ab ' + money(Math.floor(best.total / best.qty)); });
      }
      renderPurchase();
    }

    bundleWraps.forEach(function (wrap) {
      wrap.addEventListener('click', function (e) {
        var tile = e.target.closest('[data-pf-bundle-tile]');
        if (!tile) return;
        state.qty = parseInt(tile.getAttribute('data-pf-bundle-tile'), 10);
        renderPurchase();
      });
    });

    root.querySelectorAll('[data-pf-qty-dec]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.qty = Math.max(1, state.qty - 1);
        renderPurchase();
      });
    });
    root.querySelectorAll('[data-pf-qty-inc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.qty = state.qty + 1;
        renderPurchase();
      });
    });

    // ---------- accordion ----------
    root.querySelectorAll('[data-pf-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-pf-accordion-item]');
        if (!item) return;
        var willOpen = !item.classList.contains('is-open');
        item.classList.toggle('is-open', willOpen);
        var sign = trigger.querySelector('[data-pf-accordion-sign]');
        if (sign) sign.textContent = willOpen ? '–' : '+';
      });
    });

    // ---------- add to cart (AJAX) ----------
    root.querySelectorAll('[data-pf-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-pf-add-to-cart]');
        var status = form.querySelector('[data-pf-form-status]');
        if (btn) { btn.disabled = true; btn.dataset.origText = btn.dataset.origText || btn.textContent; }
        if (status) status.textContent = '';

        var fd = new FormData(form);
        fd.set('quantity', state.qty);
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw res.data;
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (status) { status.textContent = 'Zum Warenkorb hinzugefügt.'; status.style.color = 'var(--pf-accent-700)'; }
            if (btn) btn.textContent = btn.dataset.origText;
            if (window.jQuery) { try { window.jQuery(document).trigger('cart:build'); } catch (e2) {} }
          })
          .catch(function (err) {
            if (status) { status.textContent = (err && err.description) || 'Fehler beim Hinzufügen.'; status.style.color = '#b3261e'; }
            if (btn) btn.textContent = btn.dataset.origText;
          })
          .finally(function () {
            if (btn) btn.disabled = false;
            updateAddToCartState();
          });
      });
    });

    renderSelection();
    renderDrawerList();
    renderPurchase();
  }

  function boot() {
    document.querySelectorAll('[data-pf-root]').forEach(initProduktseiteFarbfinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();